import { clsx } from "clsx";
import {useSortable} from '@dnd-kit/sortable';
import {CSS} from '@dnd-kit/utilities';
import DotsIcon from "../../icons/dots.svg";
import EditIcon from "../../icons/edit.svg";
import DeleteIcon from "../../icons/delete.svg";
import BoutIcon from "../../icons/bout.svg";

function Reason(props) {
	
	const { setNodeRef, setActivatorNodeRef, attributes, listeners, transform, transition } = useSortable({ id: props.reason.id });
  const sortableStyle = { transform: CSS.Transform.toString(transform), transition };
	
	const reasonType = props.reason.type === "for" ? "For" : props.reason.type === "against" ? "Against" : "For/Against";

	const nonEditStatus = ['CG', 'DS'];
	const beginBoutStatus = ['Default', 'Moot'];

	const style = {
		reasonContainer: "relative p-2 border-t-2 border-zinc-900",
		reasonType: "font-semibold",
		reasonFlexBox: "my-2 flex flex-col",
		reasonControls: "absolute top-2 right-1 flex justify-center gap-x-2",
		reasonControlItem: "cursor-pointer",
		status: {
			container: "flex absolute top-1 left-2 gap-x-2 items-center",
			text: "text-xs"
		},
		icon: {
			moveButton: "w-[22px] cursor-grab",
			button: "p-1 border border-black/50 rounded-md w-[24px] cursor-pointer",
			edit: "hover:bg-slate-300",
			delete: "hover:bg-red-600",
		},
		controlGroup: "flex justify-center gap-2.5",
		button: "font-bold mb-2 px-4 py-1 text-sm text-slate-50 rounded-full bg-violet-700 hover:bg-violet-800 cursor-pointer",
	};

	function openConfirmationModal(action) {
		let actionData = {
			action: action
		}
		if (action == 'delRtp') {
			actionData.data = {
				playerId: props.playerId,
				reasonId: props.reason.id,
				reason: props.reason.reason
			}
		}
		if (action == 'moveRip') {
			actionData.data = {
				playerId: props.ownerId,
				reasonId: props.reason.id,
				reason: props.reason.reason
			}
		}
		props.openConfirmActionModal(actionData)
	}

	return (
		<div className={clsx(
				style.reasonContainer,
				props.reason.type === "for" && "bg-lighter-blue/10",
				props.reason.type === "against" && "bg-persuaded-green/10"
			)}
			ref={setNodeRef} style={sortableStyle} {...attributes}>
			<div className={style.reasonType}>{reasonType}</div>
			<div>{props.reason.reason}</div>
			<div className={style.status.container}>
				{props.playerId === props.ownerId ?
					(
						<button
							ref={setActivatorNodeRef}
							{...listeners}
							aria-label="Move Reason"
							className={style.icon.moveButton}>
							<DotsIcon />
						</button>
					) : null}
				<div className={style.status.text}>[{props.reason.status}]</div>
			</div>
			<div className={style.reasonControls}>
				{props.ownerId === props.playerId && !nonEditStatus.includes(props.reason.status) ? (
					<>
						<button
							aria-label="Edit Reason"
							className={`${style.icon.button} ${style.icon.edit}`}
							onClick={() => props.openEditReasonForm("rtp", props.playerId, props.reason)}>
							<EditIcon />
						</button>
						<button
							aria-label="Delete Reason"
							className={`${style.icon.button} ${style.icon.delete}`}
							onClick={() => openConfirmationModal('delRtp')}>
							<DeleteIcon />
						</button>
					</>
				) : null}
				{props.role === "referee" && beginBoutStatus.includes(props.reason.status) ? (
					<>
						<button
							aria-label="Begin Bout"
							className={`${style.icon.button} ${style.icon.edit}`}
							onClick={() => openConfirmationModal('moveRip')}>
							<BoutIcon />
						</button>
					</>
				) : null}
			</div>
		</div>
	);
}

export default Reason;
